import {
  useExportFeedbackViaEmail,
  useFetchRecordCount,
} from '@modules/common/hooks';
import { useGetFeedDuration, useGetFeedWhereClause } from '@modules/feed/hooks';
import { ChatRounded } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { TimeUnit } from 'generated/graphql';
import { TimeRange } from 'v2/core/entities';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { useGetExportFeedbackRecordsModal } from 'v2/views/components/ExportFeedbackRecordsModalContent/hooks';

export const DashboardFeedExportFeedbackAction = () => {
  const [exportFeedbackViaEmail] = useExportFeedbackViaEmail({
    exportedFrom: 'Dashboard Page',
  });

  const whereClause = useGetFeedWhereClause();
  const duration = useGetFeedDuration();

  const { data: feedbackCount } = useFetchRecordCount({
    queryContainer: {
      DateRange: duration as TimeRange,
      WhereClause: whereClause ?? EmptyWhereClause,
      AggregatePeriod: TimeUnit.Week,
    },
  });

  const exportFeedbackModal = useGetExportFeedbackRecordsModal({
    feedbackCount,
    exportFeedback: async ({ includeContent, includeOriginalContent }) => {
      await exportFeedbackViaEmail({
        queryContainer: {
          DateRange: duration as TimeRange,
          WhereClause: whereClause ?? EmptyWhereClause,
          AggregatePeriod: TimeUnit.Week,
        },
        includeContent,
        includeOriginalContent,
      });
    },
  });

  return (
    <MenuItem onClick={exportFeedbackModal}>
      <ListItemIcon>
        <ChatRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>Export Feedback</ListItemText>
    </MenuItem>
  );
};
